import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=496f9a4a&"
import script from "./SocialMedia.vue?vue&type=script&lang=js&"
export * from "./SocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496f9a4a')) {
      api.createRecord('496f9a4a', component.options)
    } else {
      api.reload('496f9a4a', component.options)
    }
    module.hot.accept("./SocialMedia.vue?vue&type=template&id=496f9a4a&", function () {
      api.rerender('496f9a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/SocialMedia.vue"
export default component.exports